exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".popup-select{position:fixed;top:0;left:0;right:0;bottom:0;overflow-y:auto;z-index:1000;text-align:left;color:#444;z-index:4;list-style:none;background-color:#fff}.popup-select li{font-size:.35rem;line-height:2}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-09cb88bd","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/PopupSelect.vue
// module id = 404
// module chunks = 0